import { useContent } from "../../Core/Content/Provider";
import { PageHeaderPiece } from "../../Shared/Layout/Pieces";
import { getAboutPillarsFn, getAboutWorkflowFn } from "./Functions";
import { AboutPillarPiece, WorkflowStepPiece } from "./Pieces";

export const AboutComponent = () => {
  const content = useContent("about");
  const home = useContent("home");
  const pillars = getAboutPillarsFn();
  const workflow = getAboutWorkflowFn();

  return (
    <section className="section-shell">
      <PageHeaderPiece
        eyebrow={content.eyebrow}
        title={content.title}
        description={content.description}
      />
      <div className="studio-about-image"><img src={home.heroImage} alt={home.heroAlt} /><span>Creative by instinct.<br/>Intentional in every frame.</span></div>
      <div className="grid gap-6 lg:grid-cols-3">
        {pillars.map((pillar) => (
          <AboutPillarPiece
            key={pillar.title}
            description={pillar.description}
            title={pillar.title}
          />
        ))}
      </div>
      <div className="panel-surface mt-10 p-6 sm:p-8">
        <p className="text-xs font-black uppercase text-cmj-gold">Workflow</p>
        <div className="mt-5 grid gap-4">
          {workflow.map((step, index) => (
            <WorkflowStepPiece index={index} key={step} step={step} />
          ))}
        </div>
      </div>
    </section>
  );
};
